import CompanyUserModal from './companyUserModal'

export default CompanyUserModal
